import { FormGroup, FormArray } from '@angular/forms';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { keyBy, orderBy, filter as lodashFilter, countBy } from 'lodash-es';
import { LIST_OF_ALL_ADDRESS_FIELDS, LIST_OF_HQ_FIELDS } from './map-fields-form.const';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DUPLICATE_FIELD_ERROR } from 'src/app/modals/integration-settings/shared/constants';

@Component({
    selector: 'app-map-fields-form',
    templateUrl: './map-fields-form.component.html',
    styleUrls: ['./map-fields-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MapFieldsFormComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() exportType: string;
    @Input() mappingType: string;
    @Input() mappings: Array<any>;
    @Input() fields: Array<any>;
    @Input() disableForm: any;
    @Input() useFullName: boolean;

    @Input() lastVisitedDateMappedFields: string[] = [];

    fieldArray;
    exportControlName: string;
    leadSource: any;
    readonly duplicateFieldError = DUPLICATE_FIELD_ERROR;

    ngOnInit(): void {
        this.exportControlName = this.exportType.toLowerCase() + 'Field';
        this.fieldArray = orderBy(this.fields, ['label'], ['asc']);
        this.leadSource = lodashFilter(this.fieldArray, item => item['field'] === 'LeadSource');
        const fieldsDict = keyBy(this.fieldArray, 'field');
        this.mappings?.forEach(item => {
            if (item.isCustomizable === false) {
              const field = fieldsDict[item[this.exportControlName]];
              if (field) {
                item['label'] = field['label'];
              }
            }
        });
        if (this.disableForm) {
            this.form.disable();
        }
        this.form.markAllAsTouched();
    }

    isValid(selectedSalesintelField) {
        const countFields = countBy(
            this.form.value[this.mappingType].filter(x => x[this.exportControlName] !== ''),
            this.exportControlName
        );

        this.form.value[this.mappingType].forEach((element, index) => {

            if (element.salesintelField === selectedSalesintelField && element.isBug) {
                element.isBug = false;
                this.form.controls[this.mappingType]['controls'][index].setValue(element);
            }

            element.isError = (countFields[element[this.exportControlName]] > 1)
                || (this.lastVisitedDateMappedFields?.includes(element[this.exportControlName]));
        });
    }

    allowOverwriteChanged(event: MatSlideToggleChange, salesIntelField: string): void {
        const isChecked = event.checked;
        let fieldsGroup: string[] = [];

        if (LIST_OF_ALL_ADDRESS_FIELDS.includes(salesIntelField)) {
            fieldsGroup = LIST_OF_ALL_ADDRESS_FIELDS;
        } else if (LIST_OF_HQ_FIELDS.includes(salesIntelField)) {
            fieldsGroup = LIST_OF_HQ_FIELDS;
        }

        if (fieldsGroup.length) {
            const formArray = this.form.get(this.mappingType) as FormArray;
            formArray.controls.forEach(ctrl => {
                const element = ctrl.value;
                if (fieldsGroup.includes(element.salesintelField)) {
                    ctrl.get('allowOverwrite').setValue(isChecked);
                }
            });
        }
    }
}
